import React from "react";

import { withPageTitle } from "srx-shared";

import { DASHBOARD_TITLE } from "config";

export default withPageTitle(DASHBOARD_TITLE)(() => (
  <h3 data-testid="welcome-text">Welcome!</h3>
));
